import React from "react";
import "./ParchmentCard.css";

/**
 * iCRAFTZ Design System · <ParchmentCard>
 *
 * The elemental container. Every card in the app is either this
 * directly or a specialised variant (JourneyCard, PanelRow, etc.).
 *
 * Props
 * ─────
 * elevation    'flat' | 'default' | 'elevated'   default 'default'
 * interactive  boolean — adds hover-lift + focus ring
 * grain        boolean — adds subtle noise texture overlay
 * as           string — element tag (default 'div'; use 'a' or 'button' for interactive)
 */
export function ParchmentCard({
  elevation = "default",
  interactive = false,
  grain = false,
  className = "",
  as: Tag = "div",
  children,
  ...rest
}) {
  const cls = [
    "icz-card",
    elevation !== "default" ? `icz-card--${elevation}` : "",
    interactive ? "icz-card--interactive" : "",
    grain ? "icz-card--grain" : "",
    className,
  ].filter(Boolean).join(" ");
  return <Tag className={cls} {...rest}>{children}</Tag>;
}

export default ParchmentCard;
